// extracted by mini-css-extract-plugin
export default {"defaults":"PrimaryButton_defaults__Jc0sC","bright":"PrimaryButton_bright__s-OZL","disabled":"PrimaryButton_disabled__TErim"};